import type { en } from "./en";

// Spanish translations. Missing keys fall back to English via i18next.
export const es: typeof en = {
  common: {
    home: "Inicio",
    no_scores: "Aún no hay puntos",
    points_count_one: "{{count}} punto",
    points_count_other: "{{count}} puntos",
    questions_count_one: "{{count}} pregunta",
    questions_count_other: "{{count}} preguntas",
  },
  home: {
    placeholder: "Código de juego",
    enter: "Entrar",
    error_invalid_code:
      "Escribe el código de juego de 6 caracteres que te dio tu profe.",
    footer: "Inicia un Binogi Buzz desde los productos de Binogi.com.",
    language_label: "Idioma",
  },
  errors: {
    generic: "Algo salió mal. Inténtalo de nuevo.",
    stale_client: "Tu página está desactualizada; recárgala.",
    session_not_found: "No se encontró esta sesión.",
    session_not_open: "Esta sesión ha terminado.",
    session_not_active: "Esta pregunta o sesión ya ha terminado.",
    not_teacher: "Solo el profesor puede hacer eso.",
    already_answered: "Ya has respondido a esta pregunta.",
    wrong_question_index: "Esta pregunta aún no ha empezado.",
    name_taken: "Ese nombre ya está en uso. Prueba con otro.",
    character_busy: "No pudimos darte un personaje ahora mismo; inténtalo de nuevo.",
  },
  host: {
    input: {
      heading: "Inicia un Buzz",
      lead:
        "Escribe el código de la lección de Binogi que están estudiando tus estudiantes. Cargaremos sus preguntas y crearemos una sesión que puedes proyectar en la pizarra.",
      lesson_code_label: "Código de lección",
      placeholder_code: "BIH750",
      load_button: "Cargar lección",
      try_hint: "Prueba:",
      error_invalid_code: "Escribe un código de lección de Binogi, p. ej. BIH750.",
      error_not_found: "No se encontró ninguna lección con el código {{code}}.",
      error_unreachable: "No se pudo conectar con el servidor de lecciones. Revisa tu conexión e inténtalo de nuevo.",
      error_no_questions: "La lección {{code}} no tiene preguntas que Buzz pueda usar.",
      error_no_level_questions: "La lección {{code}} no tiene preguntas del nivel elegido.",
    },
    loading: "Cargando lección…",
    placeholder_title: "Inicia un Binogi Buzz",
    tab_details: "Detalles",
    tab_questions: "Preguntas",
    settings: "Ajustes",
    number_of_students: "Número de estudiantes",
    fewer_students: "Menos estudiantes",
    more_students: "Más estudiantes",
    player_names: "Nombres de jugadores",
    player_anonymous: "Anónimo",
    player_self_chosen: "Los estudiantes eligen",
    language: "Idioma",
    language_teacher: "Elige el profe",
    language_students: "Eligen los estudiantes",
    time_per_question: "Tiempo por pregunta",
    time_option: "{{seconds}} s",
    start_button: "Iniciar sesión",
    start_disabled: "Indica el tamaño de la clase para empezar",
    creating: "Creando sesión…",
    error_no_questions: "Deja al menos una pregunta antes de empezar.",
    error_create_failed: "No se pudo crear la sesión",
    error_load_failed: "No se pudo cargar la lección",
    no_session: "No hay ninguna sesión en curso.",
    back_to_review: "Volver a las preguntas",
    errors: {
      dismiss: "Cerrar",
      refresh: "Recargar",
      attach_failed: "Esta pantalla no pudo conectarse como profesor.",
      unreachable: "No se pudo conectar con el servidor. Recarga la página para intentarlo de nuevo.",
      no_token: "Esta pestaña ya no puede controlar el quiz. Abre Buzz desde tu lección para iniciar una nueva sesión.",
      taken_over: "Este quiz ahora se controla desde otra pantalla.",
      stale_question: "Buzz se actualizó durante este quiz, así que esta pantalla ya no puede continuarlo. Recarga la página para continuar el quiz donde está la clase.",
      question_moved_on: "El quiz ya ha avanzado, así que esta pantalla se ha quedado atrás. Recarga la página para continuar el quiz donde está la clase.",
    },
    entry: {
      opening: "Abriendo la vista del profesor…",
      token_title: "No se puede abrir este enlace de profesor",
      token_body: "Al enlace le falta la clave del profesor o ha caducado. Abre Buzz desde tu lección para crear una nueva sesión.",
      not_found_title: "Sesión no encontrada",
      not_found_body: "Esta sesión de quiz ya no existe. Crea una nueva para continuar.",
      back: "Volver al inicio",
    },
    questions: {
      drag_aria: "Arrastra para reordenar",
      remove_aria: "Eliminar pregunta",
      empty: "No quedan preguntas en esta sesión.",
      add: "Añadir",
      add_aria: "Añadir pregunta: {{text}}",
      add_all: "Añadir todas",
      add_all_n: "Añadir las {{count}} preguntas",
      more_one: "{{count}} pregunta más en esta lección",
      more_other: "{{count}} preguntas más en esta lección",
      level_easy: "Fácil",
      level_medium: "Medio",
      level_hard: "Difícil",
      multi: "Múltiple",
    },
    lobby: {
      go_to: "Ve a <strong>buzz.binogi.com</strong> y escribe:",
      or_qr: "…o escanea el código QR",
      students_joined_of: "{{joined}} de {{expected}} estudiantes se han unido",
      students_joined_one: "{{count}} estudiante se ha unido",
      students_joined_other: "{{count}} estudiantes se han unido",
      waiting: "Esperando a que se unan los estudiantes…",
      start_game: "Iniciar juego",
      connected: "Conectado",
      connecting: "Conectando…",
      copy_link: "Copiar enlace",
      copy_link_copied: "¡Copiado!",
    },
    question: {
      header: "Pregunta {{index}} de {{total}}",
      level: "Nivel {{level}}",
      none: "No hay ninguna pregunta activa.",
      answered: "Respondidas",
      top_n: "Top {{count}}",
      answers_heading: "Respuestas",
      end_question: "Terminar pregunta",
      next_question: "Siguiente pregunta",
      see_results: "Ver resultados finales",
    },
    results: {
      heading: "Resultados finales",
      all_players: "Todos los jugadores",
      end_session: "Terminar sesión",
      new_session: "Nueva sesión",
      none: "No hay jugadores en esta sesión.",
    },
  },
  join: {
    code_label: "Código de juego",
    name_label: "Tu nombre",
    name_placeholder: "Escribe tu nombre",
    join_button: "Unirme",
    joining: "Uniéndote…",
    checking: "Comprobando…",
    character_hint:
      "Cuando te unas, recibirás un nombre divertido de un personaje de Binogi.",
    error_not_found:
      "Ese código aún no es una sesión activa. Pregúntale a tu profe.",
    error_lookup_failed: "No se pudo encontrar la sesión",
    error_code_required: "Escribe el código de 6 caracteres.",
    error_name_required: "Escribe tu nombre.",
  },
  play: {
    superseded: "Estás conectado en otra pestaña — ciérrala para seguir jugando aquí.",
    back_to_join: "Volver a unirse",
    no_round: "No hay datos de la ronda.",
    not_joined: "No te has unido a ninguna sesión.",
    no_question: "No hay ninguna pregunta activa.",
    keep_awake_hint: "Toca la pantalla para que siga encendida",
    waiting: {
      you_are: "Eres",
      get_ready_named: "¡Prepárate, {{name}}!",
      get_ready: "¡Prepárate para el quiz!",
      in_room_label: "Estudiantes en la sala",
      in_room_one: "{{count}} estudiante en la sala",
      in_room_other: "{{count}} estudiantes en la sala",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "¡Respondida!",
      times_up: "Se acabó el tiempo",
      submit: "Enviar",
      submit_n: "Enviar {{count}} respuestas",
    },
    between: {
      correct: "¡Correcto!",
      wrong: "¡Casi!",
      times_up: "Se acabó el tiempo",
      points_gained: "+{{count}} puntos",
      your_score: "Tu puntuación",
      your_rank: "Estás en el puesto {{rank}}",
      top_n: "Top {{count}}",
      waiting_next: "Esperando la siguiente pregunta…",
    },
    finished: {
      heading: "¡Gracias por jugar a Binogi Buzz!",
      your_final_rank: "Tu puesto final",
      top_n: "Top {{count}}",
      none: "No hay resultados que mostrar.",
    },
  },
  characters: {
    heading: "Personajes de Binogi",
    lead:
      "{{count}} estudiantes reciben un personaje al unirse, en este orden.",
  },
};
